import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, ArrowUp } from "lucide-react";
import { SITE } from "@/data/site";

export default function FloatingButtons() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const waLink = `https://wa.me/${SITE.phoneIntl.replace("+", "")}?text=${encodeURIComponent(SITE.whatsappMessage)}`;

  return (
    <>
      {/* Floating WhatsApp */}
      <motion.a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.8, duration: 0.5 }}
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl shadow-emerald-500/30 hover:scale-110 transition-transform duration-300"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <MessageCircle strokeWidth={1.6} className="w-6 h-6 relative" />
      </motion.a>

      {/* Back to top */}
      <AnimatePresence>
        {showTop && (
          <motion.button
            initial={{ opacity: 0, scale: 0.7 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.7 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-24 right-6 z-40 w-11 h-11 rounded-full bg-stone-900 text-[#F9F6F0] flex items-center justify-center shadow-xl hover:bg-stone-800 transition-colors"
            aria-label="Retour en haut"
            data-testid="floating-top"
          >
            <ArrowUp strokeWidth={1.5} className="w-5 h-5" />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
}
